module.exports = __webpack_public_path__ + "img/CheckCircle.0cd67c66.svg";